// extracted by mini-css-extract-plugin
export default {"container":"DatePicker_container__g-X2a","label":"DatePicker_label__vq4od","datePicker":"DatePicker_datePicker__HLhBZ"};